/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ line: NonNullable<unknown> }} Event_Style_Summary_Position_OtherInputs */



/**
* | output |
* | --- |
* | "Line {line}" |
*
* @param {Event_Style_Summary_Position_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_style_summary_position_other = /** @type {((inputs: Event_Style_Summary_Position_OtherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Style_Summary_Position_OtherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ligne ${i?.line}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeile ${i?.line}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Linea ${i?.line}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Линия ${i?.line}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Línea ${i?.line}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`线 ${i?.line}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ライン ${i?.line}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लाइन ${i?.line}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Linha ${i?.line}`)
	return /** @type {LocalizedString} */ (`Line ${i?.line}`)
});